import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-icon" }
const _hoisted_4 = { class: "detail-field" }
const _hoisted_5 = { class: "detail-field" }
const _hoisted_6 = { class: "detail-field" }
const _hoisted_7 = { class: "detail-field" }
const _hoisted_8 = { class: "detail-field" }

import { computed, ref, watch } from "vue";
import AppAddressField from "@/shared/components/ui/AppAddressField.vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessAddressSetupStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const line1 = ref("");
const line2 = ref("");
const city = ref("");
const state = ref("");
const zip = ref("");
const country = ref("");
const latitude = ref("");
const longitude = ref("");

watch(
  () => props.profileInfo,
  (info) => {
    if (!info) return;

    const address = info?.address || {};
    const line1Value = address?.line_1 || "";
    const line2Value = address?.line_2 || "";
    const cityValue = address?.city || "";
    const stateValue = address?.state || "";
    const zipValue = address?.zip || "";
    const countryValue = address?.country || "";
    const latitudeValue = address?.latitude || address?.lat || "";
    const longitudeValue = address?.longitude || address?.lng || "";

    if (!line1.value && line1Value) line1.value = String(line1Value);
    if (!line2.value && line2Value) line2.value = String(line2Value);
    if (!city.value && cityValue) city.value = String(cityValue);
    if (!state.value && stateValue) state.value = String(stateValue);
    if (!zip.value && zipValue) zip.value = String(zipValue);
    if (!country.value && countryValue) country.value = String(countryValue);
    if (!latitude.value && latitudeValue) latitude.value = String(latitudeValue);
    if (!longitude.value && longitudeValue) longitude.value = String(longitudeValue);
  },
  { immediate: true },
);

function getErrorsForField(field: string): string[] {
  const errs: any = props.errors;
  if (!errs) return [];

  const root = errs?.errors && typeof errs.errors === "object" ? errs.errors : errs;
  const raw = root?.[field];
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map((value) => String(value));
  return [String(raw)];
}

const line1Errors = computed(() => getErrorsForField("line_1"));
const line2Errors = computed(() => getErrorsForField("line_2"));
const cityErrors = computed(() => getErrorsForField("city"));
const stateErrors = computed(() => getErrorsForField("state"));
const zipErrors = computed(() => getErrorsForField("zip"));

function handleAddressSelected(payload: Record<string, any> | null) {
  if (!payload || typeof payload !== "object") return;

  const line1Value = String([payload.number, payload.street].filter(Boolean).join(" ")).trim();
  const line2Value = String(payload.unit ?? "").trim();
  const cityValue = String(payload.city ?? "").trim();
  const stateValue = String(payload.state ?? "").trim();
  const zipValue = String(payload.zipcode ?? payload.zip ?? "").trim();
  const countryValue = String(payload.country ?? "").trim();
  const latitudeValue = String(payload.latitude ?? payload.lat ?? "").trim();
  const longitudeValue = String(payload.longitude ?? payload.lng ?? "").trim();

  if (line1Value) line1.value = line1Value;
  if (line2Value) line2.value = line2Value;
  if (cityValue) city.value = cityValue;
  if (stateValue) state.value = stateValue;
  if (zipValue) zip.value = zipValue;
  if (countryValue) country.value = countryValue;
  if (latitudeValue) latitude.value = latitudeValue;
  if (longitudeValue) longitude.value = longitudeValue;
}

function getValues() {
  return {
    line_1: line1.value,
    line_2: line2.value,
    city: city.value,
    state: state.value,
    zip: zip.value,
    country: country.value,
    latitude: latitude.value,
    longitude: longitude.value,
  };
}

__expose({ getValues });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#e8612f"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("mdi-map-marker-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "step-content" }, [
        _createElementVNode("h2", { class: "title" }, "Business Address"),
        _createElementVNode("p", { class: "desc" }, "Add your business address details.")
      ], -1))
    ]),
    _createVNode(_component_v_form, { class: "details-stack" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AppAddressField, {
            modelValue: line1.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((line1).value = $event)),
            label: "Address Line 1",
            "label-icon": "mdi-map-marker-outline",
            placeholder: "123 Main St",
            variant: "outlined",
            "prepend-inner-icon": "",
            "hide-details": "",
            "error-messages": line1Errors.value,
            onSelected: handleAddressSelected
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppTextField, {
            modelValue: line2.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((line2).value = $event)),
            label: "Address Line 2",
            "label-icon": "mdi-home-outline",
            placeholder: "Suite, Apt, etc.",
            "error-messages": line2Errors.value
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(AppTextField, {
            modelValue: city.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((city).value = $event)),
            label: "City",
            "label-icon": "mdi-city-variant-outline",
            placeholder: "New York",
            "error-messages": cityErrors.value
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _createVNode(_component_v_row, { class: "detail-grid" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(AppTextField, {
                    modelValue: state.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state).value = $event)),
                    label: "State",
                    "label-icon": "mdi-map-outline",
                    placeholder: "NY",
                    "error-messages": stateErrors.value
                  }, null, 8, ["modelValue", "error-messages"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(AppTextField, {
                    modelValue: zip.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((zip).value = $event)),
                    label: "ZIP",
                    "label-icon": "mdi-mailbox-outline",
                    placeholder: "10001",
                    "error-messages": zipErrors.value
                  }, null, 8, ["modelValue", "error-messages"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})